import React from 'react';

interface FlagProps {
  className?: string;
}

export const FlagGB: React.FC<FlagProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="United Kingdom flag">
    <rect width="30" height="20" fill="#00247d" />
    <path d="M0,0 L30,20 M30,0 L0,20" stroke="#fff" strokeWidth="4" />
    <path d="M0,0 L30,20 M30,0 L0,20" stroke="#cf142b" strokeWidth="1.3" />
    <path d="M15,0 V20 M0,10 H30" stroke="#fff" strokeWidth="6.5" />
    <path d="M15,0 V20 M0,10 H30" stroke="#cf142b" strokeWidth="4" />
  </svg>
);

export const FlagRU: React.FC<FlagProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Russian flag">
    <rect width="30" height="20" fill="#fff" />
    <rect y="6.667" width="30" height="13.333" fill="#0039a6" />
    <rect y="13.333" width="30" height="6.667" fill="#d52b1e" />
  </svg>
);

export const FlagES: React.FC<FlagProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Spanish flag">
    <rect width="30" height="20" fill="#aa151b" />
    <rect y="5" width="30" height="10" fill="#f1bf00" />
  </svg>
);

export const FLAG_COMPONENTS: Record<string, React.FC<FlagProps>> = {
  en: FlagGB,
  ru: FlagRU,
  es: FlagES,
};
